<template>
  <div id="index" ref="appRef">
    <div class="bg login_box">
      <div class="login_content">
        <h1>融AI大数据可视化平台</h1>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="65px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="username">
            <el-input
              type="text"
              v-model="ruleForm.loginname"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary " @click="submitForm">登录</el-button>
            <el-button @click="resetForm" class="test">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import { getSession } from '@/api/login/login';
import { Message } from 'element-ui';
import { fullScreen } from '@/utils/index';

export default {
  data() {
    return {
      ruleForm: {
        loginname: '',
        password: ''
      },
      rules: {
        loginname: [
          { required: true, message: '请输入登录名', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    async submitForm() {
      /**
       * 调用登录接口
       * 成功：
       *     保存token
       *     跳转到首页，并给出成功的提示
       * 失败：给出错误提示，让用户重新登录
       */

      getSession(this.ruleForm).then((response) => {
        if (response.code === '0') {
          // 成功
          Message.success('登录成功');
          // 设置token
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.userName);
          // 跳转
          this.$router.push({ name: 'home' });
          // 全屏
          fullScreen();
        } else {
          Message.error(response.message);
          console.error(response);
        }
      });
    },
    /**
     * 登录函数
     */
    resetForm() {
      this.ruleForm.username = '';
      this.ruleForm.password = '';
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';

.login_box {
  width: 100%;
  height: 100%;
  //background-color: #324057;
  position: relative;

  .login_content {
    width: 35%;
    height: 350px;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    position: absolute;
    top: 30%;
    left: 30%;
    padding-top: 2%;

    h1 {
      text-align: center;
      width: 100%;
      height: 40px;
      line-height: 40px;
    }

    .demo-ruleForm {
      padding: 30px;

      .test {
        background-color: #999;
        color: white;
      }
    }
  }
}
</style>
